import React from 'react';

function Crop({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M7.1 3L7 15.4A1.6 1.6 0 008.6 17H21" />
      <path d="M3 7.1L15.4 7A1.6 1.6 0 0117 8.6V21" />
    </svg>
  );
}

export default Crop;
